import { EndpointBuilder } from '@reduxjs/toolkit/query';
import {
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta
} from '@reduxjs/toolkit/query';
import { BaseQueryFn } from '@reduxjs/toolkit/query';
import { BlockLoadSyncResponse } from '../../types';
import { NFMSFilter } from '../../types/records/feeder-master-data';
import { NFMSSyncBlockLoadRecord } from '../../types/records/block-load-sync';

export const blockLoadSyncEndpoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      NonNullable<unknown>,
      FetchBaseQueryMeta
    >,
    string,
    'nfmsApi'
  >
) => ({
  getBlockLoadSyncListView: builder.mutation<
  BlockLoadSyncResponse,
    NFMSFilter
  >({
    query: (data) => ({
      url: `block_load_logging/consumers/`,
      method: 'POST',
      body: data
    }),
    invalidatesTags: []
  }),

  getBlockLoadFailedListView: builder.query<NFMSSyncBlockLoadRecord,  { transaction_id: string; nfms_sync_status: string }>({
    query: ({ transaction_id, nfms_sync_status })=> ({
      url: `transactional_data/block_load/${transaction_id}/${nfms_sync_status}`,
      method: 'GET',
    }),
  })
  
});
